import { Box, Stack, Typography } from "@mui/material";
import React, { useContext } from "react";
import { Radar } from "react-chartjs-2";
import { darkerGrey, green } from "../../shared/colours";
import { greenTransparent } from "../../shared/colours";
import { ThemeModeContext } from "../../shared/Theme";

const CompanyEmployeeCoursesRadar = (props) => {

	const themeModeContext = useContext(ThemeModeContext);
	
	const options = {
		plugins: {
			legend: {
				display: false
			},
		},
		scales: {
			r: {
				pointLabels: {
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 12
					}
				},
				ticks: {
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					},
					callback: function() {return ""},
					backdropColor: 'rgb(0, 0, 0, 0)',
					
				}
			},
		},
		elements: {
			line: {
				borderWidth: 3
			}
		},
		responsive: true,
		maintainAspectRatio: false
	};
	
	const getData = () => {
		const filteredCourseResults = {};
		for (let i in props.employeeCourses) {
			let course = props.employeeCourses[i];
			if (course.category === null) continue;
			if (!filteredCourseResults.hasOwnProperty(course.category)) {
				filteredCourseResults[course.category] = { totalScore: 0, entryCount: 0 };
			}
			filteredCourseResults[course.category].totalScore += course.score;
			filteredCourseResults[course.category].entryCount += 1;
		}
		
		let radarData = [];
		for (let i in filteredCourseResults) {
			let course = filteredCourseResults[i];
			let score = Math.round(course.totalScore / course.entryCount);
			radarData.push({ label: i, value: score });
		}
		radarData = radarData.sort((a, b) => {
			if (a.label < b.label) {
				return 1;
			}
			else if (a.label > b.label) {
				return -1;
			}
			return 0;
		});
		
		
		const data = {
			labels: [],
			datasets: [{
				label: "",
				data: [],
				fill: true,
				backgroundColor: greenTransparent,
				borderColor: green,
				pointBackgroundColor: greenTransparent,
				pointBorderColor: green,
				pointHoverBackgroundColor: '#fff',
				pointHoverBorderColor: 'rgb(255, 99, 132)'
			}]
		};
		
		for (let i in radarData) {
			let rD = radarData[i];
			data.labels.push(rD.label);
			data.datasets[0].data.push(rD.value);
		}
		
		return data;
	}
	
	return (
		props.employeeCourses?
			<Box sx={{
				width: "50%"
			}}>
				<Stack direction="column">
					<Typography sx={{ width: "100%", fontWeight: "bold", textAlign: "center" }}>
						Course Results
					</Typography>
				</Stack>
				<Box sx={{ height: "500px" }}>
					<Radar data={getData()} options={options}/>
				</Box>
			</Box>
		: <React.Fragment/>
	);

}

export default CompanyEmployeeCoursesRadar;